import React, {useState, useEffect, useRef} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Panel} from "primereact/panel";
import {InputText} from "primereact/inputtext";
import {Checkbox} from "primereact/checkbox";
import {RadioButton} from "primereact/radiobutton";
import axios from "axios";

const CandidateListComponent = (props) => {

  const {t, onDetailedSearchActiveChange} = props;
  const history = useHistory();
  const {entity} = useParams();
  const [candidates, setCandidates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [detailedSearchVisible, setDetailedSearchVisible] = useState(false);
  const [detailedSearchQuery, setDetailedSearchQuery] = useState('');
  const isDetailedSearchActive = React.useMemo(() => {
    return (detailedSearchQuery || '').toString().trim().length > 0;
  }, [detailedSearchQuery]);
  
  const [langRelation, setLangRelation] = useState('and');
  const [dsApplicationDate, setDsApplicationDate] = useState('');
  const [dsAge, setDsAge] = useState('');
  const [dsGender, setDsGender] = useState('');
  const [dsResidenceCounty, setDsResidenceCounty] = useState(null);
  const [dsResidenceCity, setDsResidenceCity] = useState('');
  const [dsResidenceAddress, setDsResidenceAddress] = useState('');
  const [dsPermCounty, setDsPermCounty] = useState(null);
  const [dsPermCity, setDsPermCity] = useState('');
  const [dsPermStreet, setDsPermStreet] = useState('');

  const [dsEducationLevel, setDsEducationLevel] = useState(null);
  const [dsEducationName, setDsEducationName] = useState('');
  const [dsInstitution, setDsInstitution] = useState('');
  const [dsGraduationYear, setDsGraduationYear] = useState('');
  const [dsNoEducation, setDsNoEducation] = useState(null);
  const [dsNoEducationUploaded, setDsNoEducationUploaded] = useState(null);
  const [dsCompanyName, setDsCompanyName] = useState('');
  const [dsPosition, setDsPosition] = useState('');

  const [dsItSkills, setDsItSkills] = useState(null);
  const [dsItNone, setDsItNone] = useState(null);
  const [dsDriverLicense, setDsDriverLicense] = useState(null);
  const [dsDriverNone, setDsDriverNone] = useState(null);

  const [dsLang1, setDsLang1] = useState(null);
  const [dsLang1Level, setDsLang1Level] = useState(null);
  const [dsLang2, setDsLang2] = useState(null);
  const [dsLang2Level, setDsLang2Level] = useState(null);
  const [dsNoLanguageUploaded, setDsNoLanguageUploaded] = useState(null);

  const [dsJobInterest, setDsJobInterest] = useState(null);
  const [dsWorkRegion, setDsWorkRegion] = useState(null);
  const [dsAdSourceRegion, setDsAdSourceRegion] = useState(null);
  const [dsApplicant, setDsApplicant] = useState(null);
  const [dsHasVehicle, setDsHasVehicle] = useState(null);
  const [dsStudent, setDsStudent] = useState(null);
  const [dsPartTimeOnly, setDsPartTimeOnly] = useState(null);
  const [dsNewsletter, setDsNewsletter] = useState(null);
  const [dsConfirmed, setDsConfirmed] = useState(null);
  const [dsMarkedBy, setDsMarkedBy] = useState('');
  const [dsSource, setDsSource] = useState('');

  const [dsBirthPlace, setDsBirthPlace] = useState('');
  const [dsActive, setDsActive] = useState(null);
  const [dsIsEmployee, setDsIsEmployee] = useState(null);
  const [dsTrainee, setDsTrainee] = useState(null);

  const [dsName, setDsName] = useState('');
  const [dsEmail, setDsEmail] = useState('');
  const [dsTaxNumber, setDsTaxNumber] = useState('');
  const [dsInsuranceNumber, setDsInsuranceNumber] = useState('');
  const [dsPhone, setDsPhone] = useState('');

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      const baseQuery = window.App.transformQueryParams(lazyParams);
      const query = mergeQueries(baseQuery, detailedSearchQuery);
      apiCall('get', '/api/v2/candidate' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setCandidates(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const buildDetailedSearchQuery = () => {
    let parts = [];
    const like = (field, val) => {
      const v = (val ?? '').toString().trim();
      if (!v) return;
      parts.push(`search[${field}][operator]=like&search[${field}][value]=*${encodeURIComponent(v)}*`);
    };
    like('name', dsName);
    like('email', dsEmail);
    like('tax_number', dsTaxNumber);
    like('insurance_number', dsInsuranceNumber);
    like('phone', dsPhone);
    like('birth_place', dsBirthPlace);
    if (dsActive !== null) parts.push(`search[active][operator]==&search[active][value]=${dsActive}`);
    if (dsIsEmployee !== null) parts.push(`search[is_employee][operator]==&search[is_employee][value]=${dsIsEmployee}`);
    if (dsTrainee !== null) parts.push(`search[trainee][operator]==&search[trainee][value]=${dsTrainee}`);
    return parts.filter(Boolean).join('&');
  };

  const normalizeQuery = (q) => {
    const s = (q || '').toString().trim();
    if (!s) return '';
    return s.startsWith('?') ? s.slice(1) : s;
  };

  const mergeQueries = (baseQuery, extraQuery) => {
    const a = normalizeQuery(baseQuery);
    const b = normalizeQuery(extraQuery);
    const merged = [a, b].filter(Boolean).join('&');
    return merged ? `?${merged}` : '';
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_recruitment_candidate_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'candidate') {
                      history.push('/recruitment/candidate/update/' + rowData.id)
                    }
                  }}/>
        }
        <Button
        icon="pi pi-eye"
        className="p-button p-mr-2"
        tooltip={t('view')}
        tooltipOptions={{ position: 'left' }}
        onClick={() => {
          history.push('/recruitment/candidate/read/' + rowData.id);
        }}
      />
        {localStorage.getItem('roles').toString().includes('role_recruitment_candidate_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      setLoading(true);
                      apiCall('delete', '/api/v2/candidate/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!');
                          window.App.setState({rerenderCandidateList: Math.random()})
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                        })
                        .finally(() => {
                          setLoading(false);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderCandidateList])

  useEffect(() => {
    if (typeof onDetailedSearchActiveChange === 'function') {
      onDetailedSearchActiveChange(isDetailedSearchActive);
    }
  }, [isDetailedSearchActive, onDetailedSearchActiveChange]);

  return (
    <>
      <div className={"p-grid p-mb-2"}>
        <div className={"p-col-12 p-text-right"}>
          <Button
            type="button"
            label={t('detailedSearch')}
            icon={isDetailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
            className="p-button-outlined"
            onClick={() => setDetailedSearchVisible(!detailedSearchVisible)}
          />
        </div>
      </div>

      {detailedSearchVisible && (
        <Panel className="p-mb-2  candidate-ds-panel" onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              if (document.activeElement) document.activeElement.blur();
              setTimeout(() => {
                const searchBtn = document.querySelector('button.p-button-primary .pi-search')?.parentElement;
                if (searchBtn) searchBtn.click();
              }, 100);
            }
          }}>
          <div className={"p-grid"}>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid p-mb-3">
                <label>{t('columnName2')}</label>
                <InputText value={dsName} onChange={(e) => setDsName(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldTaxIdentifier')}</label>
                <InputText value={dsTaxNumber} onChange={(e) => setDsTaxNumber(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldSocialSecurityNumberShort')}</label>
                <InputText value={dsInsuranceNumber} onChange={(e) => setDsInsuranceNumber(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldApplicationDate')}</label>
                <InputText value={dsApplicationDate} onChange={(e) => setDsApplicationDate(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('columnEmail')}</label>
                <InputText value={dsEmail} onChange={(e) => setDsEmail(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldAge')}</label>
                <InputText value={dsAge} onChange={(e) => setDsAge(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldGender')}</label>
                <Dropdown
                  value={dsGender}
                  onChange={(e) => setDsGender(e.value)}
                  placeholder={t('dsSelect')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldPhoneContact')}</label>
                <InputText value={dsPhone} onChange={(e) => setDsPhone(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldResidenceCounty')}</label>
                <Dropdown
                  value={dsResidenceCounty}
                  options={[]}
                  onChange={(e) => setDsResidenceCounty(e.value)}
                  placeholder={t('dsSelectCounty')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldResidenceCity')}</label>
                <InputText value={dsResidenceCity} onChange={(e) => setDsResidenceCity(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldResidenceAddress')}</label>
                <InputText value={dsResidenceAddress} onChange={(e) => setDsResidenceAddress(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldAddressCounty')}</label>
                <Dropdown
                  value={dsPermCounty}
                  onChange={(e) => setDsPermCounty(e.value)}
                  showClear
                  placeholder={t('dsSelectCounty')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldHomeAddressCity')}</label>
                <InputText value={dsPermCity} onChange={(e) => setDsPermCity(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldAddressStreet')}</label>
                <InputText value={dsPermStreet} onChange={(e) => setDsPermStreet(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-0">
                <label>{t('columnActive')}</label>
                <Dropdown
                  value={dsActive}
                  onChange={(e) => setDsActive(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldDegreeLevel')}</label>
                <Dropdown
                  value={dsEducationLevel}
                  onChange={(e) => setDsEducationLevel(e.value)}
                  showClear
                  placeholder={t('dsSelectLevel')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldEducationName')}</label>
                <InputText value={dsEducationName} onChange={(e) => setDsEducationName(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldInstitution')}</label>
                <InputText value={dsInstitution} onChange={(e) => setDsInstitution(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldGraduationYear')}</label>
                <InputText value={dsGraduationYear} onChange={(e) => setDsGraduationYear(e.target.value)} />
              </div>

              <div className="p-field p-mb-4">
                <div className="p-field-checkbox p-mb-2 p-d-flex p-ai-center p-jc-start">
                  <Checkbox inputId="dsNoEducation" checked={!!dsNoEducation} onChange={(e) => setDsNoEducation(e.checked)} />
                  <label htmlFor="dsNoEducation" className="p-ml-2">{t('fieldNoEducation')}</label>
                </div>

                <div className="p-field-checkbox p-mb-2 p-d-flex p-ai-center p-jc-start">
                  <Checkbox inputId="dsNoEducationUploaded" checked={!!dsNoEducationUploaded} onChange={(e) => setDsNoEducationUploaded(e.checked)} />
                  <label htmlFor="dsNoEducationUploaded" className="p-ml-2">{t('fieldNoEducationUploaded')}</label>
                </div>
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldCompanyLegalName')}</label>
                <InputText value={dsCompanyName} onChange={(e) => setDsCompanyName(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-0">
                <label>{t('fieldJobTitle')}</label>
                <InputText value={dsPosition} onChange={(e) => setDsPosition(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldComputerSkills')}</label>
                <div className="p-d-flex p-ai-center">
                  <div className="p-flex-1 p-pr-2">
                    <Dropdown
                      value={dsItSkills}
                      options={[]}
                      onChange={(e) => setDsItSkills(e.value)}
                      showClear
                      placeholder={t('dsSelect')}
                    />
                  </div>
                  <div className="p-field-checkbox p-m-0 p-d-flex p-ai-center">
                    <Checkbox value={dsItNone} checked={!!dsItNone} onChange={(e) => setDsItNone(e.checked)} />
                    <label className={"p-ml-2"}>{t('fieldNoneFilled')}</label>
                  </div>
                </div>
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldDrivingLicenses')}</label>
                <div className="p-d-flex p-ai-center">
                  <div className="p-flex-1 p-pr-2">
                    <Dropdown
                      value={dsDriverLicense}
                      options={[]}
                      onChange={(e) => setDsDriverLicense(e.value)}
                      showClear
                      placeholder={t('dsSelect')}
                    />
                  </div>
                  <div className="p-field-checkbox p-m-0">
                    <Checkbox value={dsDriverNone} checked={!!dsDriverNone} onChange={(e) => setDsDriverNone(e.checked)} />
                    <label className={"p-ml-2"}>{t('fieldNoneFilled')}</label>
                  </div>
                </div>
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldFirstLanguage')}</label>
                <div className="p-d-flex">
                  <div className="p-col-12 p-md-6 p-pr-2">
                    <Dropdown
                      value={dsLang1}
                      options={[]}
                      onChange={(e) => setDsLang1(e.value)}
                      showClear
                      placeholder={t('dsSelectLanguage')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <Dropdown
                      value={dsLang1Level}
                      options={[]}
                      onChange={(e) => setDsLang1Level(e.value)}
                      showClear
                      placeholder={t('dsSelectLevel')}
                    />
                  </div>
                </div>
              </div>

              <div className="p-field p-mb-3">
                <div className="p-d-flex p-ai-center">
                  <RadioButton
                    inputId="langAnd"
                    name="langRelation"
                    value="and"
                    onChange={(e) => setLangRelation(e.value)}
                    checked={langRelation === 'and'}
                  />
                  <label htmlFor="langAnd" className="p-ml-2 p-mr-4">{t('fieldAnd')}</label>

                  <RadioButton
                    inputId="langOr"
                    name="langRelation"
                    value="or"
                    onChange={(e) => setLangRelation(e.value)}
                    checked={langRelation === 'or'}
                  />
                  <label htmlFor="langOr" className="p-ml-2">{t('fieldOr')}</label>
                </div>
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldSecondLanguage')}</label>
                <div className="p-d-flex">
                  <div className="p-col-12 p-md-6 p-pr-2">
                    <Dropdown
                      value={dsLang2}
                      options={[]}
                      onChange={(e) => setDsLang2(e.value)}
                      showClear
                      placeholder={t('dsSelectLanguage')}
                    />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <Dropdown
                      value={dsLang2Level}
                      options={[]}
                      onChange={(e) => setDsLang2Level(e.value)}
                      showClear
                      placeholder={t('dsSelectLanguage')}
                    />
                  </div>
                </div>
              </div>

              <div className="p-field p-fluid p-mb-0">
                <div className="p-field-checkbox p-m-0">
                  <Checkbox value={dsNoLanguageUploaded} checked={!!dsNoLanguageUploaded} onChange={(e) => setDsNoLanguageUploaded(e.checked)} />
                  <label className={"p-ml-2"}>{t('fieldNoLanguageUploaded')}</label>
                </div>
              </div>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldInterestedJobs')}</label>
                <Dropdown
                  value={dsJobInterest}
                  options={[]}
                  onChange={(e) => setDsJobInterest(e.value)}
                  showClear
                  placeholder={t('dsSelectJobType')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldPreferredWorkLocation')}</label>
                <Dropdown
                  value={dsWorkRegion}
                  options={[]}
                  onChange={(e) => setDsWorkRegion(e.value)}
                  showClear
                  placeholder={t('dsSelectRegion')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldAdSourceQuestion')}</label>
                <Dropdown
                  value={dsAdSourceRegion}
                  options={[]}
                  onChange={(e) => setDsAdSourceRegion(e.value)}
                  showClear
                  placeholder={t('dsSelectRegion')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldCareerStarter')}</label>
                <Dropdown
                  value={dsApplicant}
                  onChange={(e) => setDsApplicant(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldHasVehicle')}</label>
                <Dropdown
                  value={dsHasVehicle}
                  onChange={(e) => setDsHasVehicle(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldStudent')}</label>
                <Dropdown
                  value={dsStudent}
                  onChange={(e) => setDsStudent(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldPartTimeOnly')}</label>
                <Dropdown
                  value={dsPartTimeOnly}
                  onChange={(e) => setDsPartTimeOnly(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldNewsletter')}</label>
                <Dropdown
                  value={dsNewsletter}
                  onChange={(e) => setDsNewsletter(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldConfirmed')}</label>
                <Dropdown
                  value={dsConfirmed}
                  onChange={(e) => setDsConfirmed(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>

              <div className="p-field p-fluid p-mb-3">
                <label>{t('fieldCandidateNoteShort')}</label>
                <InputText value={dsMarkedBy} onChange={(e) => setDsMarkedBy(e.target.value)} />
              </div>

              <div className="p-field p-fluid p-mb-0">
                <label>{t('columnSource')}</label>
                <InputText value={dsSource} onChange={(e) => setDsSource(e.target.value)} />
              </div>
            </div>

            <div className={"p-col-12 p-text-right"}>
              <div className="p-d-inline-flex p-ai-center" style={{gap: '0.5rem'}}>
                <Button
                  type="button"
                  label={t('dsClearCriteria')}
                  icon="pi pi-times"
                  className="p-button-danger p-mr-2"
                  onClick={() => {
                    setDsName('');
                    setDsEmail('');
                    setDsTaxNumber('');
                    setDsInsuranceNumber('');
                    setDsPhone('');
                    setDsBirthPlace('');
                    setDsActive(null);
                    setDsIsEmployee(null);
                    setDsTrainee(null);
                    setDetailedSearchQuery('');
                    setLazyParams({ ...lazyParams, first: 0, page: 0 });
                  }}
                />
                <Button
                  type="button"
                  label={t('dsSearch')}
                  icon="pi pi-search"
                  className="p-button-primary"
                  onClick={() => {
                    const q = buildDetailedSearchQuery();
                    setDetailedSearchQuery(q);
                    setLazyParams({ ...lazyParams, first: 0, page: 0 });
                  }}
                />
              </div>
            </div>

          </div>
        </Panel>
      )}

      <DataTable size={localStorage.getItem('scale')}
                emptyMessage={t('noResults')}
                value={candidates} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                paginatorTemplate={pager} rows={rows}
                autoLayout={true}
                filterDisplay="row"
                responsiveLayout="scroll"
                stripedRows
                ref={dt}
                dataKey="id"
      >
        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable filter></Column>

        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )

}
export default withTranslation('common')(CandidateListComponent);